import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { Footer } from '../../src/components/footer/mod';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';
import { AuthContextService } from '../app/Services/authContext.service';
import { GeneralService } from '../app/Services/general.service';
import { UserSettingsService } from '@public/src/application/services/user_settings.service';
import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { I18nAndL10n } from '@public/src/modules/i18n_and_l10n/mod';
import { sharedResolution } from '../../src/shared_resolution';
import { Root, createRoot } from 'react-dom/client';

const containerElementName = 'reactFooterComponent';

@Component({
	standalone: false,
	selector: 'footer-component',
	template: ` <div class="wrapper-container" #${containerElementName}></div> `,
	encapsulation: ViewEncapsulation.None,
})
export class FooterWrapperComponent implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(
		private readonly authContextService: AuthContextService,
		private readonly generalService: GeneralService,
		private readonly ngZone: NgZone,
	) {
		// Empty
	}

	ngOnChanges(_: SimpleChanges): void {
		this.render();
	}

	ngAfterViewInit(): void {
		this.render();
	}

	private setLanguage(languageCode: string): void {
		localStorage.setItem('languageCode', languageCode);

		if (this.authContextService.isSignedIn()) {
			this.generalService.setlanguage(languageCode).subscribe(
				() => {
					window.location.reload();
				},
				() => {
					// noop
				},
			);
		} else {
			window.location.reload();
		}
	}

	ngOnDestroy(): void {
		this.root?.unmount();
	}

	private render(): void {
		const userSettingsService = sharedResolution.resolve(UserSettingsService);
		const analyticService = sharedResolution.resolve(AnalyticService);

		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const handleLanguageChange = (code: string): void => {
			this.ngZone.run(() => {
				const convertedCode = I18nAndL10n.convertExternalLocaleToAvailableLocale(code as string);

				// TODO: REMOVE THIS ONCE NOT INJECTED ANY MORE
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				//@ts-ignore
				analyticService.trackEvent(AnalyticCategories.DeviceGateway, `Changed language to: ${convertedCode}`);

				userSettingsService.updateSettings({ selectedLanguage: convertedCode });
				this.setLanguage(code);
			});
		};
		this.ngZone.runOutsideAngular(() => {
			this.root.render(
				<CellulaProviderWrapper>
					<Footer __TEMP__changeLanguage={handleLanguageChange} />
				</CellulaProviderWrapper>,
			);
		});
	}
}
